<template>
  <div class="stencilform-previews-wrapper">
    <div class="stencilform-previews-wrapper-box">
      <div class="stencilform-previews-wrapper-box-panel" v-bind:style="styleStencilPanel">
        <div class="stencilform-previews-wrapper-box-panel-canvas">
          <div class="stencilform-previews-wrapper-box-panel-canvas-svg">
            <svg viewBox="0 0 500 500">
              <text v-if="viewBoxHeight > 0" id="x-axis-label" text-anchor="middle" font-size="15" v-bind:class="textBoundsCssClass">{{textWidthInInches}}</text>
              <text v-if="viewBoxHeight > 0" id="y-axis-label" text-anchor="middle" font-size="15" v-bind:class="textBoundsCssClass" transform="translate(0 250) rotate(-90,5,0)">
                {{textHeightInInches}}
              </text>
              <line v-if="viewBoxHeight > 0" id="x-axis" stroke="red" />
              <line v-if="viewBoxHeight > 0" id="y-axis" stroke="red" />

              <svg ref="the-artwork">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" v-bind:viewBox="viewBox" width="480" height="480" x="20" y="20">
                  <path stroke="black" v-for="pathWithOffset in pathsWithOffsets"
                    v-bind:d="pathWithOffset.path.toPathData(2)"
                    v-bind:transform="pathWithOffset.transform"
                    />
                </svg>
              </svg>
            </svg>
          </div>
        </div>
      </div>

      <div class="stencilform-previews-wrapper-box-top">
        <div>
          {{materialWidth}} inch material width
          <span v-if="textWidthInInches > 120" style="color:red;">*multiple stencils</span>
        </div>
      </div>

      <div class="stencilform-previews-wrapper-box-left">
        <div>
          <div>{{materialHeight}} inch material height</div>
        </div>
      </div>

      <div class="stencilform-previews-wrapper-box-bottom"></div>
      <div class="clearfix"></div>
    </div>

    <div v-if="textWidthInInches > 120" style="font-size:1.1rem; text-align:center; margin-top: -70px; padding: 2em 4em;">
      <span style="color:red;">*</span> <strong>Note:</strong>
      When the required width is above 120 inches the stencil will be split
      into two or more.
    </div>
  </div>
</template>

<script>
import { STENCILCONST } from '../modules/constant.js.erb'

const ASSET_HOST = "//" + (process.env.ASSETS_DOMAIN || "");

export default {
  data() {
    return {
      styleStencilPanel: {
        margin: "6.5217%"
      },
      textBoundsCssClass: ""
    }
  },
  computed: {
    textHeightInInches() {
      return this.$store.getters["product/textHeightInInches"];
    },
    textWidthInInches() {
      return this.$store.getters["product/textWidthInInches"];
    },
    svgPaths() {
      return this.$store.getters["product/svgPaths"];
    },
    pathsWithOffsets() {
      // Zip paths with their offsets
      return this.svgPaths.map(
        (path, index) => {
          return {
            transform: `translate(${this.svgPathOffsets[index]} 0)`,
            path: path
          };
        });
    },
    svgPathOffsets() {
      const boxWidth = bb => Math.abs(bb.x2 - bb.x1);
      const stage_width = boxWidth(this.boundingBox);
      const align_fn = ((alignment) => {
        if(alignment == "left") {
          return ((_) => 0);
        } else if (alignment == "right") {
          return (box =>  Math.abs(boxWidth(box) - stage_width));
        } else if (alignment == "center") {
          return (box => Math.abs(boxWidth(box) - stage_width) / 2);
        }
      })(this.$store.state.product.textAlign);

      return this.svgPaths
        .map(path => path.getBoundingBox())
        .map(box => align_fn(box));
    },
    boundingBox() {
      return this.$store.getters["product/boundingBox"];
    },
    viewBoxHeight() {
      return this.$store.getters["product/viewBoxHeight"];
    },
    viewBox() {
      if(this.boundingBox) {
        const {x1, y1, x2, y2} = this.boundingBox;
        const pad = 1;

        const min_x  = Math.floor(Math.min(x1, x2)) - pad;
        const min_y  = Math.floor(Math.min(y1, y2)) - pad;
        const width  = Math.ceil(Math.abs(x1 - x2)) + pad;
        const height = Math.ceil(Math.abs(y1 - y2)) + pad;

        return `${min_x} ${min_y} ${width} ${height}`;
      }
    },
    materialWidth() {
      const width = this.$store.getters["product/materialWidth"];
      return Math.round(width * 100) / 100;
    },
    materialHeight() {
      const width = this.$store.getters["product/materialHeight"];
      return Math.round(width * 100) / 100;
    },
    textWidth() {
    },
  },
  created: function() {
     this.$store.subscribe( (mutation, state) => {
      if (mutation.type === 'product/setTextHeight') {
        this.textBoundsCssClass = "call-attention";
        window.setTimeout(() => {this.textBoundsCssClass = ""}, 3000);
      }
    })
  },
  updated: function() {
    if(this.$refs['the-artwork']) {
      // Globally store a copy of the rendered artwork at STENCILCONST._svg,
      // this is sent to the server.
      let node = this.$refs['the-artwork'].children[0].cloneNode(true);

      node.removeAttribute('x');
      node.removeAttribute('y');
      node.removeAttribute('width');
      node.removeAttribute('height');
      node.querySelectorAll('path').forEach(path => path.setAttribute('fill', 'none'));
      STENCILCONST._svg = node.outerHTML;

      this.$nextTick(function () {
        const padding = 8;
        const {x, y, width, height} = this.$refs['the-artwork'].getBBox();
        const x_axis = document.getElementById('x-axis');
        const x_axis_label = document.getElementById('x-axis-label');
        const y_axis = document.getElementById('y-axis');
        const y_axis_label = document.getElementById('y-axis-label');

        // X-Axis Label
        if(x_axis_label) {
          x_axis_label.setAttribute('x', '50%');
          x_axis_label.setAttribute('y', y - 1.5*padding);
          x_axis_label.innerHTML = `${this.textWidthInInches} inches`;
        }

        // Y-Axis Label
        if(y_axis_label) {
          y_axis_label.setAttribute('transform', `translate(${x - 1.5*padding} 250) rotate(-90)`);
          y_axis_label.innerHTML = `${this.textHeightInInches} inches`;
        }

        // X-Axis
        if(x_axis) {
          x_axis.setAttribute('x1', x);
          x_axis.setAttribute('y1', y - padding);
          x_axis.setAttribute('x2', x + width);
          x_axis.setAttribute('y2', y - padding);
        }

        // Y-Axis
        if(y_axis) {
          y_axis.setAttribute('x1', x - padding);
          y_axis.setAttribute('y1', y);
          y_axis.setAttribute('x2', x - padding);
          y_axis.setAttribute('y2', y + height);
        }
      });
    }
  }
}
</script>
